module.exports = __webpack_public_path__ + "img/1441603254.6a6861f4.jpg";